import React from 'react';
import { Button, Modal } from 'lmc-ui-library';
import styles from './../../CaseDetailsPage.module.scss';
import { useDispatch } from 'react-redux';
import { viewValidationErrors } from '../store/useCases';
import css from './Styles.module.scss';

const ValidationFailed = () => {
  const dispatch = useDispatch();

  const onViewErrorsClick = () => {
    dispatch(viewValidationErrors());
  };

  return (
    <>
      <Modal.Header title="Validating data..." className={styles.modalHeader} />
      <Modal.Content className={css.modalContent}>
        <h2 className={css.danger}>Error!</h2>
        <div className={css.contentText}>Some fields are showing incorrect data. Please review and amend</div>
      </Modal.Content>
      <Modal.Footer style={{ display: 'grid' }}>
        <Button mode="ghost" borderVariant="rectangle" className={styles.actionButton} onClick={onViewErrorsClick}>
          View errors
        </Button>
      </Modal.Footer>
    </>
  );
};

export default ValidationFailed;
